import { render, staticRenderFns } from "./vue-formulate-autocomplete.vue?vue&type=template&id=3d0346af&"
import script from "./vue-formulate-autocomplete.vue?vue&type=script&lang=js&"
export * from "./vue-formulate-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports